import { useSelector } from "react-redux";
import Banner from "../../components/Banner/Banner";
import ExpertServices from "../../components/ExpertServices/ExpertServices";
import Main from "../../components/Main/_index";
import Partner from "../../components/Partner/Partner";
import Question from "../../components/Question/Question";
import Story from "../../components/Story/Story";
import Swipers from "../../components/Swiper/Swiper";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";
import MyParallax from "../../uikit/Parallax/Parallax";

const Home = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <>
      <Main
        backimg="/img/homeback.jpg"
        title={translations[selectedLanguages].homeMain.title}
        context={translations[selectedLanguages].homeMain.context}
        btn={translations[selectedLanguages].homeMain.button}
      />
      <ExpertServices />
      <MyParallax />
      <Partner />
      <Story />
      <Question />
      <Swipers />
      <Banner />
    </>
  );
};

export default Home;
